<template>
  <div class="w-full h-full flex flex-col items-center bg-backgroundColor">
    <BannerSection :banner="banner" :loading="loading" />
    <div class="w-[94%] md:w-[75%] 2xl:w-[60%] pt-16">
      <p class="pt-2 pb-5 text-justify">{{ section.name }}</p>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        <div v-for="item in items" :key="item.id">
          <img v-if="item.icon" :src="item.icon" alt="icon" />
        </div>
      </div>
      <div class="pt-3 text-justify">
        <p>{{ section.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import BannerSection from "@/components/BannerSection.vue";
import { db } from "@/firebaseConfig";
import { addDoc, collection, getDocs, orderBy, query } from "firebase/firestore";
export default {
  name: "CentralMonitoringResponseServicePage",
  components: {BannerSection},
  data() {
    return {
      banner: {},
      loading: true,
      items: [],
      section: {
        name: "",
        description: "",
      },
    };
  },
  mounted() {
    this.fetchBanner();
    this.fetchMainDoc();
    
  },
  methods: {
    async fetchBanner() {
      try {
        const snapshot = await getDocs(collection(db, "centralBanner"));
        const firstDoc = snapshot.docs[0];
        if (firstDoc) {
          this.banner = { id: firstDoc.id, ...firstDoc.data() };
        }
      } catch (e) {
        console.error("Error fetching banner:", e);
      } finally {
        this.loading = false;
      }
    },
    async fetchMainDoc() {
      const snapshot = await getDocs(collection(db, "centralContent"));
      if (!snapshot.empty) {
        const docSnap = snapshot.docs[0];
        this.mainDocId = docSnap.id;
        this.section = {
          name: docSnap.data().name,
          description: docSnap.data().description,
        };
        this.fetchItems();
      } else {
        // Create new main doc if not exist
        const mainDocRef = await addDoc(collection(db, "centralContent"), {
          name: "",
          description: "",
        });
        this.mainDocId = mainDocRef.id;
      }
    },
    async fetchItems() {
      const q = query(
        collection(db, "centralContent", this.mainDocId, "items"),
        orderBy("orderNumber", "asc")
      );
      const snapshot = await getDocs(q);
      this.items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    },
  },
};
</script>
